import { makeStyles, createStyles } from "@material-ui/core/styles";
import colors from "./colors";

const common = {
  borderRadius: "24px",
  fontSize: "16px",
  fontFamily: "Roboto, sans-serif",
  lineHeight: "28px",
  padding: "10px 24px",
};

const common14px = {
  borderRadius: "24px",
  fontSize: "14px",
  fontFamily: "Roboto, sans-serif",
  lineHeight: "24px",
  padding: "12px 20px",
};

const commonWithBorder = {
  borderRadius: "24px",
  fontSize: "16px",
  fontFamily: "Roboto, sans-serif",
  lineHeight: "26px",
  padding: "10px 24px",
};

export const lightButtonWithBorder = {
  backgroundColor: colors.whiteColor,
  color: colors.primaryColor,
  border: `1px solid ${colors.darkGreyColor}`,
  borderRadius: "24px",
  fontSize: "16px",
  fontFamily: "Roboto, sans-serif",
  lineHeight: "28px",
  textTransform: "none",
};

const useButtonStyles = makeStyles(() =>
  createStyles({
    primaryButton: {
      backgroundColor: colors.primaryColor,
      color: colors.secondaryColor,
      "&:hover": {
        backgroundColor: colors.primaryColor,
      },
      ...common,
      textTransform: "none",
      "&.MuiButton-root.Mui-disabled": {
        backgroundColor: colors.grey,
        color: colors.secondaryColor,
      },
    },
    primaryButtonLargeWidth: {
      backgroundColor: colors.primaryColor,
      color: colors.secondaryColor,
      "&:hover": {
        backgroundColor: colors.primaryColor,
      },
      ...common,
      "&.MuiButton-root.Mui-disabled": {
        backgroundColor: colors.grey,
        color: colors.secondaryColor,
      },
      width: "352px !important"
    },
    primaryButton14px: {
      backgroundColor: colors.primaryColor,
      color: colors.secondaryColor,
      "&:hover": {
        backgroundColor: colors.primaryColor,
      },
      ...common14px,
      textTransform: "none",

      "&.MuiButton-root.Mui-disabled": {
        backgroundColor: colors.grey,
        color: colors.secondaryColor,
      },
    },
    inactiveButton: {
      backgroundColor: colors.darkGreyColor,
      color: colors.secondaryColor,
      "&:hover": {
        backgroundColor: colors.darkGreyColor,
      },
      ...common,
      textTransform: "none",

      "&.MuiButton-root.Mui-disabled": {
        backgroundColor: colors.grey,
        color: colors.secondaryColor,
      },
    },
    secondaryButton: {
      backgroundColor: colors.veryLightGreyColor,
      border: `1px solid ${colors.darkGreyColor}`,
      color: colors.darkGreyColor,
      ...common,
      textTransform: "none",

    },
    lightButton: {
      backgroundColor: colors.whiteColor,
      border: `1px solid ${colors.darkGreyColor}`,
      color: colors.darkGreyColor,
      ...commonWithBorder,
      textTransform: "none",

      "&.MuiButton-root:hover": {
        backgroundColor: colors.whiteColor,
      },
    },
    lightButtonLargeWidth: {
      backgroundColor: colors.whiteColor,
      border: `1px solid ${colors.darkGreyColor}`,
      color: colors.darkGreyColor,
      ...commonWithBorder,
      textTransform: "none",

      "&.MuiButton-root:hover": {
        backgroundColor: colors.whiteColor,
      },
      width: "352px !important"
    },
    lightButtonNoBorder: {
      backgroundColor: colors.whiteColor,
      color: colors.primaryColor,
      ...common,
      textTransform: "none",

      "&:hover": {
        backgroundColor: colors.secondaryColor,
      },
    },
    lightButtonWithBorder: {
      backgroundColor: colors.whiteColor,
      color: colors.darkGreyColor,
      border: `1px solid ${colors.darkGreyColor}`,
      ...common,
      textTransform: "none",

      "&:hover": {
        backgroundColor: colors.secondaryColor,
      },
    },
    lightButtonWithBorderLargeWidth: {
      backgroundColor: colors.whiteColor,
      color: colors.darkGreyColor,
      border: `1px solid ${colors.darkGreyColor}`,
      ...common,
      textTransform: "none",

      "&:hover": {
        backgroundColor: colors.secondaryColor,
      },
      width: "352px !important"
    },
  })
);

export default useButtonStyles;
